import React from "react";
import { useParams } from "react-router-dom";
import {
  getLibrariesSection,
  LIBRARIES_DEFAULT_SECTION,
} from "./librariesNav";
import LibrariesComingSoon from "./LibrariesComingSoon";
import AgencyProfilesPage from "./AgencyProfiles/AgencyProfilesPage";
import CareFacilitiesPage from "./CareFacilities/CareFacilitiesPage";
import InsuranceCarriersPage from "./Insurance/InsuranceCarriersPage";
import ReferralSourcesPage from "./Referral/ReferralSourcesPage";
import PharmacyDirectoryPage from "./Pharmacy/PharmacyDirectoryPage";
import PhysicianDirectoryPage from "./Physician/PhysicianDirectoryPage";
import StaffPayRatesPage from "./StaffPayRates/StaffPayRatesPage";
import ClinicalCosignersPage from "./ClinicalCosigners/ClinicalCosignersPage";

/**
 * Per-sub-module content. Implemented catalogs render here;
 * others stay on Coming Soon until built.
 */
const LibrariesSectionPage = () => {
  const { sectionId } = useParams();
  const id = sectionId || LIBRARIES_DEFAULT_SECTION;
  const section = getLibrariesSection(id);

  if (id === "agencies") return <AgencyProfilesPage />;
  if (id === "facility") return <CareFacilitiesPage />;
  if (id === "insurance") return <InsuranceCarriersPage />;
  if (id === "referrer") return <ReferralSourcesPage />;
  if (id === "pharmacy") return <PharmacyDirectoryPage />;
  if (id === "physician") return <PhysicianDirectoryPage />;
  if (id === "payroll-rates") return <StaffPayRatesPage />;
  if (id === "cosigners") return <ClinicalCosignersPage />;

  return <LibrariesComingSoon section={section} />;
};

export default LibrariesSectionPage;
